<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/I2AKwM/tc-custom/9781609456610.jpg?1726755912781" alt="This image is the cover for the book Thirst"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thirst
      </h1>
      <p class="bookDescription body article font2">
        <b>The prize-winning author “entices lucky readers with a dissenting, potentially heretical, refreshingly fascinating interpretation” of Jesus’s life (<i>Shelf Awareness</i>).</b><br/><br/>The Francophone Belgian author Amélie Nothomb has won high praise for her provocative and philosophical novels, including <i>Fear and Trembling</i>, which won the prestigious Prix du Roman. Now Nothomb presents a highly original reexamination of an all-too-familiar story.<br/><br/>In a first-person voice as wry as it is wise, Nothomb narrates Jesus’s final days, from his trial to his crucifixion to the resurrection. Amid asides about his relationships with his mother and Judas, his love for Mary Magdalene, and his many miracles, we find a man struggling with his humanity and his exceptional nature, straddling the line between human and deity, the son of a formless, omnipotent creator in the fallible form of a man.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amélie Nothomb
      </h2>
      
      <p class="authorDescription body article"><P><B>Amélie Nothomb</B> was born in Japan to Belgian parents in 1967. She lives in Paris. Her books have been translated into twenty-five languages and counting, and been awarded numerous prizes including the French Academy’s Grand Prix for the Novel, the René-Fallet, Alain-Fournier, and Jean-Giono prizes.</P><br/><br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?98cfc17c